import Initiative from 'components/framework/models/Initiative';
import RecordFields from '../RecordFields';
import { registerRecordFieldsClasses } from './index';

export default class InitiativeFields extends RecordFields {
  static modelClass = Initiative;
}

registerRecordFieldsClasses({ InitiativeFields });
